import { render, staticRenderFns } from "./store.vue?vue&type=template&id=b2b823ce&scoped=true&"
import script from "./store.vue?vue&type=script&lang=ts&"
export * from "./store.vue?vue&type=script&lang=ts&"
import style0 from "./store.vue?vue&type=style&index=0&id=b2b823ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b823ce",
  null
  
)

export default component.exports